module.exports = __webpack_public_path__ + "static/img/0000挂缴查2.ce556a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/picImgs/0000挂缴查2.jpg
// module id = vSVB
// module chunks = 0